import { Check, PenLine } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";

type KeywordCardProps = {
	confirmed: boolean;
	value: string;
	words: readonly string[];
	onChange: (value: string) => void;
	onConfirm: () => void;
};

export function KeywordCard({ confirmed, value, words, onChange, onConfirm }: KeywordCardProps) {
	const [editing, setEditing] = useState(false);
	return (
		<section className="section-block keyword-section">
			<article className={cn("keyword-card", confirmed && "locked")}>
				<div className="keyword-card-head">
					<div className="keyword-heading">
						<h2>今天留下一个词</h2>
						<span>给此刻一个轻轻的命名</span>
					</div>
				</div>
				{editing ? (
					<form
						className="keyword-input-row"
						aria-label="确认今日关键词"
						onSubmit={(event) => {
							event.preventDefault();
							onConfirm();
						}}
					>
						<input
							aria-label="今日关键词"
							placeholder="输入你的今日关键词…"
							readOnly={confirmed}
							value={value}
							onChange={(event) => onChange(event.target.value)}
						/>
						<button
							type="submit"
							className="keyword-confirm"
							disabled={confirmed || !value.trim()}
							aria-label={confirmed ? "今日关键词已确认" : "确认今日关键词"}
						>
							<Check size={21} />
						</button>
					</form>
				) : null}
				<div className="keyword-choices">
					<div className="summary-tags keyword-tags">
						{words.map((word) => (
							<button
								type="button"
								key={word}
								disabled={confirmed}
								className={cn(value === word && "active")}
								onClick={() => {
									onChange(word);
									setEditing(true);
								}}
							>
								{word}
							</button>
						))}
					</div>
					<button
						className="keyword-edit"
						type="button"
						disabled={confirmed}
						aria-label={confirmed ? "今日关键词已确认" : "编辑今日关键词"}
						onClick={() => setEditing(!editing)}
					>
						{confirmed ? <Check size={20} /> : <PenLine size={20} />}
					</button>
				</div>
				{confirmed && value ? <p className="keyword-saved">今天的关键词：{value}</p> : null}
			</article>
		</section>
	);
}
